import React, { useCallback, useEffect, useState } from "react";
import AdminSidebar from "./Components/MenuSidebar";
import AdminHeader from "./../Admin/Components/AdminHeader";
import { useDispatch, useSelector } from "react-redux";
import { PaginationType } from "../../Constants/Interfaces";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { getConversationAction } from "../../Services/Store/Actions/MessageConversationsAction";
import { showToast } from "../../utils/helpers";
import AddChatMessages from "../../Components/AddChatMessages";
import PanelWrapper from "./PanelWrapper";
import ActionMenu from "../../Components/ActionMenu";
import { useLocation } from "react-router";
import Pagination from "../../Components/Pagination";

const MessagesPage = () => {
  const dispatch = useDispatch();
  const { conversations } = useSelector((state: any) => state.messages);
  // Shared by /user/messages and /admin/messages — pick sidebar by route.
  const { pathname } = useLocation();
  const panelType: "admin" | "user" = pathname.startsWith("/admin")
    ? "admin"
    : "user";

  const [loading, setLoading] = useState(false);
  const [conversationList, setConversationList] = useState([]);
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  const [showMessageBox, setShowMessageBox] = useState({
    show: false,
    partner: "",
  });

  const getConversations = useCallback(
    (page: number = 1) => {
      if (!loading) {
        setLoading(true);

        getConversationAction({ page, limit: 20 }, dispatch)
          .then((res) => {
            if (res.type === "success") {
              if (res.data && res.data.pagination) {
                setPagination(res.data.pagination);
              }
            } else {
            }
          })
          .catch((err) => {
            showToast("error", err.message);
          })
          .finally(() => setLoading(false));
      }
    },
    [pagination],
  );

  useEffect(() => {
    setConversationList(conversations);
  }, [conversations]);

  useEffect(() => {
    getConversations();
  }, []);

  return (
    <PanelWrapper type={panelType}>
      <div className="container">
        <div className="page-header">
          <h2>Messages</h2>
        </div>

        <div className="page-content-card">
          <div className="listing-tables">
            <Table responsive>
              <thead>
                <tr>
                  <th style={{ width: 170 }}>User Name</th>
                  <th>Message</th>
                  <th className="action-col">Action</th>
                </tr>
              </thead>

              <tbody>
                {!loading && conversationList.length === 0 && (
                  <tr>
                    <td colSpan={3} align="center">
                      You don't have any messages yet.
                    </td>
                  </tr>
                )}

                {conversationList.length > 0 &&
                  conversationList.map((item, index) => (
                    <tr>
                      <td>{item?.user?.name}</td>
                      <td>
                        {item && item.lastMessage
                          ? String(item.lastMessage.text).substring(0, 50) +
                            "..."
                          : ""}
                      </td>
                      <td className="action-col">
                        <ActionMenu
                          items={[
                            {
                              label: "Show Message",
                              icon: faChevronRight,
                              onClick: () =>
                                setShowMessageBox({
                                  show: true,
                                  partner: item.user,
                                }),
                            },
                          ]}
                        />
                      </td>
                    </tr>
                  ))}

                {loading && (
                  <tr>
                    <td colSpan={3} align="center">
                      <FontAwesomeIcon icon={faSpinner} spin />
                    </td>
                  </tr>
                )}
              </tbody>

              <tfoot>
                <tr>
                  <td colSpan={5}>
                    <Pagination
                      pagination={pagination}
                      onPageChange={(page) => getConversations(page)}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </div>

      {showMessageBox.show && (
        <AddChatMessages
          spaceAuthor={showMessageBox.partner}
          closeChat={() => setShowMessageBox({ show: false, user: null })}
        />
      )}
    </PanelWrapper>
  );
};

export default MessagesPage;
